import CustomRegular from './customRegular';

export default {
  rules_checkPhone: {
    phone: [
      { required: true, message: '手机号不能为空', trigger: 'blur' },
      { validator: CustomRegular.checkPhone, trigger: 'blur' },
    ],
    code: [
      { required: true, message: '验证码不能为空', trigger: 'blur' },
    ],
  },

  rules_resetPassword: {
    code: [
      { required: true, message: '验证码不能为空', trigger: 'blur' },
    ],
    newPassword: [
      { required: true, message: '新密码不能为空', trigger: 'blur' },
      {
        min: 6,
        max: 32,
        message: '密码长度应为6到32位',
        trigger: 'blur',
      },
    ],
    repeatPassword: [
      { required: true, message: '重复密码不能为空', trigger: 'blur' },
      {
        min: 6,
        max: 32,
        message: '至少6位',
        trigger: 'blur',
      },
    ],
  },

  rules_login: {
    username: [
      { required: true, message: '账号不能为空', trigger: 'blur' },
      /* {validator: CustomRegular.checkPhone, trigger: 'blur'}, */
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      {
        min: 6,
        max: 32,
        message: '密码长度应为6到32位',
        trigger: 'blur',
      },
    ],
    code: [
      { required: true, message: '验证码不能为空', trigger: 'blur' },
    ],
    phone: [
      { required: true, message: '手机号不能为空', trigger: 'blur' },
      { validator: CustomRegular.checkPhone, trigger: 'blur' },
    ],
  },
  rules_example: {
    name: [
      { required: true, message: '请输入负责人姓名', trigger: 'blur' },
    ],
    terminalType: [
      { required: true, message: '请输入应用终端类型' },
      { type: 'number', message: '应用终端类型必须为数字' },
    ],
    humidityMax: [
      { required: true, message: '请输入最大湿度值' },
      {
        type: 'number',
        min: 0,
        max: 100,
        message: '湿度范围为0～100%',
      },
    ],
    newPassword: [
      { required: true, message: '请输入新密码', trigger: 'blur' },
      {
        min: 6,
        max: 32,
        message: '密码长度应为6到32位',
        trigger: 'blur',
      },
    ],
    phone: [
      { required: true, message: '请输入负责人联系方式', trigger: 'blur' },
      { validator: CustomRegular.checkPhone, trigger: 'blur' },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/utils/rules/index.js